module.exports = __webpack_public_path__ + "img/onlineumfrage.493c2aaa.png";